var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fdw-ticker',{attrs:{"client":"114","accent-color":"#E42C2C"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }